import type {
  ContentfulErrorKeys,
  IEntryGraphInputGeneric,
  IEntryInputGeneric,
  IErrorMessage,
  IErrorMessageEntry,
  IGenericInputErrorMap,
  IGenericInputFactory,
  ValidationMessage
} from '@belong/types';
import { ContentfulCollection } from 'contentful';
import { MAGIC_KEY_FOR_PUBLISHED_BUT_UNUSED_FIELDS } from '../parseFlexibleContent';

export function parseErrorMessages<E = IGenericInputErrorMap>(errorMessages: IErrorMessageEntry = []): E {
  return errorMessages.reduce(
    (acc, { fields: { errorKey, message } }) => ({
      ...acc,
      [errorKey]: message
    }),
    {}
  ) as E;
}

export function parseGraphErrorMessages<E = IGenericInputErrorMap>(
  errorMessages: ContentfulCollection<IErrorMessage>['items'] = []
): E {
  return errorMessages.reduce(
    (acc, { errorKey, message }) => ({
      ...acc,
      [errorKey]: message
    }),
    {}
  ) as E;
}

export function FGenericInput<T extends ContentfulErrorKeys>(data: IEntryInputGeneric): IGenericInputFactory<T> {
  // NOTE: 'key' prop should NOT be included in component props to avoid clashing with React keys
  // BUT: it DOES need to be included as it's currently being used to derive option values in genericInputGroup
  const { errorMessages = [], ...fields } = data.fields;

  return {
    id: data.sys.id,
    ...fields,
    errorMessages: parseErrorMessages<ValidationMessage<T>>(errorMessages)
  };
}

export function FGraphGenericInput<T extends ContentfulErrorKeys>(
  data: IEntryGraphInputGeneric
): IGenericInputFactory<T> {
  const { sys, errorMessages, ...fields } = data;

  return {
    id: data.sys.id,
    ...fields,
    key: fields.key ?? MAGIC_KEY_FOR_PUBLISHED_BUT_UNUSED_FIELDS,
    errorMessages: parseGraphErrorMessages<ValidationMessage<T>>(errorMessages?.items)
  };
}
